"use client";

import { useFeedback } from "@/components/dashboard/feedback-component";
import { IconChats } from "@teral/icons";
import { Tooltip, TooltipContent, TooltipTrigger } from "@teral/ui";
import { cn } from "cn";
import { TOP_NAV_ICON_BUTTON_CLASS } from "./icon-button";

export function TopNavFeedbackButton({
  className,
  tooltipSide = "bottom",
}: { className?: string; tooltipSide?: "bottom" | "top" }) {
  const { openFeedback } = useFeedback();
  return (
    <Tooltip>
      <TooltipTrigger
        aria-label="Give feedback"
        onClick={() => openFeedback(true, "feedback")}
        className={cn(TOP_NAV_ICON_BUTTON_CLASS, className)}
      >
        <IconChats className="size-3.5" />
      </TooltipTrigger>
      <TooltipContent side={tooltipSide}>Give feedback</TooltipContent>
    </Tooltip>
  );
}
